import type {
  UserWatchlistGroupDTO,
  UserWatchlistItemDTO,
  UserWatchlistListGroupsResultDTO,
  UserWatchlistListItemsResultDTO,
} from "./UserWatchlistType";

const WATCHLIST_GROUP_NAME_MAX = 6;

let groups: UserWatchlistGroupDTO[] = [];

let items: UserWatchlistItemDTO[] = [];

function nowStr(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export const userWatchlistMocks = {
  listGroups(): UserWatchlistListGroupsResultDTO {
    return { rows: [...groups].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)) };
  },

  createGroup(name: string): UserWatchlistListGroupsResultDTO {
    const n = name.trim();
    if (!n) {
      throw new Error("分组名称不能为空");
    }
    if (n.length > WATCHLIST_GROUP_NAME_MAX) {
      throw new Error("分组名称过长");
    }
    if (groups.some((g) => String(g.groupName ?? "").trim() === n)) {
      throw new Error("已存在同名分组");
    }
    const maxSo = groups.reduce((m, g) => Math.max(m, g.sortOrder ?? 0), 0);
    const id = `WG${Date.now().toString(36).toUpperCase()}`;
    groups.push({ id, groupName: n, sortOrder: maxSo + 1, createdAt: nowStr(), updatedAt: nowStr() });
    return userWatchlistMocks.listGroups();
  },

  deleteGroup(groupId: string): void {
    items = items.filter((x) => x.groupId !== groupId);
    groups = groups.filter((g) => g.id !== groupId);
  },

  listItems(groupId: string): UserWatchlistListItemsResultDTO {
    const rows = items.filter((x) => x.groupId === groupId);
    return { rows };
  },

  addItem(groupId: string, stockCode: string, stockName: string, addReason: string): void {
    const code = stockCode.trim().toUpperCase();
    const dupe = items.some(
      (x) => x.groupId === groupId && String(x.stockCode ?? "").toUpperCase() === code
    );
    if (dupe) {
      throw new Error("该分组下已存在此股票");
    }
    items.unshift({
      id: `W${Date.now().toString(36)}`,
      groupId,
      stockCode: code,
      stockName: stockName.trim(),
      addReason: addReason.trim().slice(0, 50),
      createdAt: nowStr(),
      updatedAt: nowStr(),
    });
  },

  removeItem(itemId: string): void {
    items = items.filter((x) => x.id !== itemId);
  },
};
